module.exports = __webpack_public_path__ + "static/media/video1.733af495.mp4";